import { H3 } from '@h3/types';
import * as Api from '../api';

import { localPlugins } from './local-plugins';

export default class PluginInstanceManager {
    private instances: H3.Plugin.Next.IPluginInstance[] = [];
    /** 当前企业引擎编码 */
    private get _engineCode() {
        return window?.h3Daf?.EngineContext?.engineCode;
    }

    get Instances() {
        return this.instances;
    }

    async init() {
        await this.getPluginInstances();
    }

    // 获取当前企业所有安装的插件
    async getPluginInstances() {
        const ret = await Api.Plugin.PluginNext.getPluginInstances(this._engineCode);
        if (!ret.errorCode) {
            this.instances = ret.data;
            this.instances.push(...localPlugins);
        }
    }

    // 根据插件编码获取插件实例
    async getPluginInstanceByCode(code: string) {
        if (!this.instances?.length) {
            await this.getPluginInstances();
        }
        const plugin = this.instances.find((plugin) => plugin.code === code);
        return plugin;
    }
}
